import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ArrowForward } from '@vedmarket/ui-kit';
import { COLORS } from '../../../../../../../../../../../../../config/constants';

const ChatInput = ({
  inputMessage, onChange, onSend, onClear, isConnected, isLoading, inputRef,
}: ChatInputProps) => {
  const { t } = useTranslation();

  const sendButtonIsDisabled = !inputMessage.trim() || !isConnected || isLoading;

  return (
    <div className='chat__input'>
      <Typography component='button' type='button' variant='caption' className='chat__new-request' onClick={onClear} sx={{ color: COLORS.BLUE }}>{t('common__text__newRequest')}</Typography>
      <TextField
        type='text'
        value={inputMessage}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && onSend()}
        disabled={!isConnected || isLoading}
        label={t("common__text__request")}
        InputLabelProps={{ shrink: true }}
        multiline
        fullWidth
        rows={2}
        inputRef={inputRef}
        sx={{
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '.MuiOutlinedInput-root': {
            height: '80px',
            padding: '8px 48px 8px 12px'
          },
          '.MuiInputBase-input': {
            fontSize: '14px',
            lineHeight: '24px'
          },
          '.MuiInputLabel-root.MuiInputLabel-shrink': {
            transform: 'translate(11px, -6px) scale(0.75)'
          },
          '.MuiInputBase-inputMultiline': {
            padding: 0
          },
          '.MuiInputLabel-root': {
            padding: '0 2px',
            background: COLORS.WHITE
          }
        }}
      />

      <IconButton
        className='chat__send'
        disabled={sendButtonIsDisabled}
        onClick={onSend}
        aria-label={t("common__text__request")}
        sx={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '24px',
          height: '24px',
          padding: 0,
          margin: 0,
          '&.MuiIconButton-root': {
            marginRight: 0,
          },
          color: COLORS.BLUE,
          '&.Mui-disabled': {
            color: COLORS.BLUE,
          },
        }}
      >
        <ArrowForward style={{ color: COLORS.BLUE }} />
      </IconButton>
    </div>
  );
};

export default ChatInput;
